// api/run-completeness.ts
//
// The incomplete-run verdict the backend attaches wherever a run's rates are
// read (app/services/run_completeness.py). A run is incomplete when its
// excluded (no answer) + failed (judge failed) calls exceed `threshold` of its
// calls. Rates are always over ANSWERED calls; an incomplete run just says so.
// A complete run carries `incomplete: false` and renders exactly as before.

export interface RunCompletenessLane {
  calls: number;
  answered: number;
  excluded_no_answer: number;
  failed_zeroed: number;
  unmeasured: number;
}

export interface RunCompleteness {
  incomplete: boolean;
  threshold: number;
  calls: number;
  answered: number;
  excluded_no_answer: number;
  failed_zeroed: number;
  unmeasured: number;
  unmeasured_share: number;
  rate_basis: "answered_calls";
  /** Only the lanes that lost calls. */
  by_lane: Record<string, RunCompletenessLane>;
}

export function isIncomplete(
  completeness: RunCompleteness | null | undefined,
): completeness is RunCompleteness {
  return Boolean(completeness?.incomplete);
}
